/**
 * Fime – Partner Logo Marquee
 *
 * NOTE: not yet wired to any markup (Partner Logos section comes later).
 */

function initLogoMarquee(selector) {
	const track = document.querySelector(selector);

	if (!track || track.dataset.initialized) return;

	track.dataset.initialized = 'true';

	const items = [...track.children];

	items.forEach((item) => {
		const clone = item.cloneNode(true);
		clone.setAttribute('aria-hidden', 'true');

		const image = clone.querySelector('img');
		if (image) {
			image.alt = '';
		}

		track.appendChild(clone);
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initLogoMarquee('.logo-track');
});
